/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { Modal } from 'antd'
import { Models } from 'rmc-tabs/lib/Models'
import { Tabs } from 'antd-mobile'
import 'antd-mobile/dist/antd-mobile.css' /* antd-mobile */
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { filter, find } from 'lodash'
import { isMobile } from 'react-device-detect'
import { useOnMount } from '@utils/reactExt'
import { appScrollTo, formatNumber, loadOrReload, showToast, TOAST_TYPE } from '@utils/utils'
import AnimatedNumber from 'animated-number-react'
import * as ErrorCodes from 'adv-protocol/src/ErrorCodes'
// icon
import { GmoneyIco, HeartIco, ScashIco } from '@shared/Icon/MoneyIcon'
import ItemShopCharacter from '@assets/images/bg/character/item-shop-character.png'
import ItemShopBg from '@assets/images/bg/item-shop-bg.png'
import QuestionIco from '@assets/images/icon/etc_icon/question-ico.png'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import sCashBtn from '@assets/images/btn/scash-btn-itemshop.png'
// css
import {
  ModalBg,
  TabTxt,
  TitleWrap,
  WhiteChildTabWrap,
  WhiteTabWrap,
} from '@styles/base.style'
import { BackBtn, Button } from '@styles/button.style'
import { ProductTrackItem } from '@store/shopStore'
import { CASH_TAB, PRICE_TYPE } from '@constants/index'
import MessageArrivalButton from '@components/Button/MessageArrivalButton'
import { globalStore, userStore } from '@store/index'
import NavBar from '@views/Navbar'
import EventFloatingButton from '@views/Matchup/EventFloatingButton'
import ProductDetail from './ProductDetail'
import {
  ButtonWrap,
  CancelButtonStyle,
  // ChargeButtonStyle,
  // Content,
  // ContentTitleStyle,
  // ContentWrapStyle,
  ItemList,
  ItemListWrapper,
  ItemShopBgWrap,
  ItemShopTitInfoBtn,
  // ItemStlye,
  // ItemWrapStlye,
  // Num,
  ScashButtonStyle,
  UserMoneyInfoWrap,
  // Wrapper,
} from './index.style'
import ProductTrack from './ProductTrack'
import DialogUtils from '@utils/dialog-utils'


// Tab
const tabs = [
  { title: <TabTxt>G머니</TabTxt>, key: '0' },
  { title: <TabTxt>아이템</TabTxt>, key: '1' },
]

const tabsChildren = [
  { title: <TabTxt className="item-shop"><ScashIco/>캐시로 구매</TabTxt>, key: '0' },
  { title: <TabTxt className="item-shop"><HeartIco/>하트로 구매</TabTxt>, key: '1' },
]

const backupTabsChildren = [...tabsChildren]

const ItemShop: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0)
  const [tab2Index, setTab2Index] = useState(CASH_TAB.S_CASH)
  const { authStore, shopStore, routerStore, logStore } = useRootStore()
  const { tracks } = shopStore
  const { signedin, userInfo, authInfo } = authStore

  const state = {
    value: userInfo.money,
    duration: 1000,
    delay: 500,
  }

  const formatValue = value => `${formatNumber(value.toFixed(0))}`

  const [detailItemId, setDetailItemId] = useState(0)
  const [visibleInsufficient, setVisibleInsufficient] = useState(false)

  const handleOk = () => {
    setTimeout(() => {
      setVisibleInsufficient(false)
    }, 100)
  }

  useOnMount(() => {
    if (!authStore.isSignedIn) {
      loadOrReload('/')
    }
    shopStore.fetch()

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  const onClickCharge = () => {
    logStore.writeButtonLog({ pageId: 'd020', buttonId: '003' }).catch(console.error)
    const url = `${isMobile ? process.env.HOMEPAGE_MO : process.env.HOMEPAGE_PC}/#/auth_login/${authInfo.authKey}/payment`
    globalStore.toMoveWebHomePage(url, 'self')
    globalStore.resetGeneralPopupProperties()
  }

  const onClickShowMoneyInfo = () => {
    DialogUtils.showMoneyInfo()
  }

  const userInfoTrack = signedin && (
    <UserMoneyInfoWrap className={!isMobile && 'pc'}>
      <div className="money-info-gmoney">
        <span className="money-info-gmoney--top">
          G머니
          {/*{formatNumber(userInfo.money)}*/}
        </span>
        <span className="money-info-gmoney--bottom">
          <span id="itemshopGmoney" className="money-num gmoney">
            <AnimatedNumber
              value={state.value}
              formatValue={formatValue}
              duration={state.duration}
              delay={state.delay}
            />
          </span>
          <GmoneyIco/>
        </span>
      </div>

      <div className="money-info-other">
        <div className="money-info-other--list">
          <span className='money-info-other--list--scash'>
            캐시
            <Button TP onClick={onClickCharge} className="charge-btn">
              <img src={sCashBtn} alt="s캐시 충전 버튼"/>
            </Button>
          </span>
          <span className='money-info-other--list--value scash'>
            <span className="money-num">
              {formatNumber(userInfo.cash)}
            </span>
            <ScashIco/>
          </span>
        </div>
        <div className="money-info-other--list">
          <Button className="money-tip-btn" onClick={onClickShowMoneyInfo}>
            하트
            <div className="money-tip-btn--ico">
              <img src={QuestionIco} alt="물음표 아이콘"/>
            </div>
          </Button>
          <span className="money-info-other--list--value heart">
            <span className="money-num">
              {formatNumber(userInfo.heart)}
            </span>
            <HeartIco/>
          </span>
        </div>
      </div>
    </UserMoneyInfoWrap>
  )

  const tabChanged = (tab: Models.TabData, index: number) => {
    setTabIndex(index)
    setTab2Index(0)
  }

  const onTab2Changed = (tab: Models.TabData, index: number) => {
    setTab2Index(index)
  }

  const onClickTrack = async (id: number) => {
    // message.info(`onClickTrack id=${id}`)

    if (id === 23) {
      const result = await userStore.getOwnedFreeLicense()
      if (result) {
        if (result.items?.length > 0) {
          DialogUtils.showUnableToCreateClub()
        } else if (result.errcode === ErrorCodes.ERR.BUY_ITEM_FAIL_ONLY_MEMBERSHIP) {
          DialogUtils.showClubCreationMembershipRequired()
        } else if (result.errcode) {
          showToast(TOAST_TYPE.INFO, '구매 실패! 잠시후 다시 시도해 주세요.')
        } else {
          setDetailItemId(id)
          console.dir(result)
        }
      }
    } else {
      setDetailItemId(id)
    }
  }


  const onClickChargeInDetail = () => {
    const url = `${isMobile ? process.env.HOMEPAGE_MO : process.env.HOMEPAGE_PC}/#/auth_login/${authInfo.authKey}/payment`
    globalStore.toMoveWebHomePage(url, 'self')
    globalStore.resetGeneralPopupProperties()
  }


  let eleChildTabs = tabsChildren

  for (const key of Object.keys(eleChildTabs)) {
    if (tabIndex === 1) {
      if (key === '1') {
        eleChildTabs.splice(parseInt(key), 1)
      } else {
        eleChildTabs = backupTabsChildren
      }
    }
  }

  const contents = []
  let filtered = filter(tracks, (el: ProductTrackItem) => {
    return el.sort[tabIndex] && el.sort[tabIndex] !== undefined
  })
  if (tab2Index >= 0) {
    let priceType
    switch (tab2Index) {
      case CASH_TAB.HEART:
        priceType = PRICE_TYPE.HEART
        break
      case CASH_TAB.S_CASH:
        priceType = PRICE_TYPE.S_CASH
        break
    }
    filtered = filter(filtered, { price_type: priceType })
  }
  for (const el of filtered) {
    const productTrackKey = `ItemShop:Contents:Col:${el.id}`
    contents.push(
      <li key={productTrackKey}>
        <ProductTrack track={el} onClickTrack={onClickTrack}/>
      </li>,
    )
  }

  const detailTrack = find(tracks, { id: detailItemId })

  return (
    <Fragment>
      <ItemShopBgWrap className={!isMobile && 'pc'}>
        <img src={ItemShopBg} alt="" className="item-shop-bg"/>
        <img src={ItemShopCharacter} alt="" className="character"/>
      </ItemShopBgWrap>

      <TitleWrap className={isMobile ? 'title-wrap no-bg itemshop-mo' : 'title-wrap no-bg itemshop-pc'}>
        {isMobile && (
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'd020', buttonId: '001' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        )}
        <EventFloatingButton className="item-shop"/>
      </TitleWrap>

      <p css={ItemShopTitInfoBtn}>
        <GmoneyIco/>머니는 게임에
        <br/>
        사용되는 <span className="point-color--yellow">재화로
        <br/>
        승부예측을</span> 하는데
        <br/>
        사용됩니다.
      </p>

      {userInfoTrack}
      <ItemListWrapper>
        <WhiteTabWrap className={isMobile ? 'item-shop-tab' : 'item-shop-tab pc'}>
          <Tabs tabs={tabs} initialPage={tabIndex} page={tabIndex} onChange={tabChanged}/>
        </WhiteTabWrap>

        <div>
          <WhiteChildTabWrap>
            <Tabs
              tabs={eleChildTabs}
              initialPage={tab2Index}
              onChange={onTab2Changed}
              renderTabBar={tabProps => {
                if (tabProps.activeTab !== tab2Index) {
                  tabProps.goToTab(tab2Index)
                }
                return <Tabs.DefaultTabBar {...tabProps} />
              }}
            />
          </WhiteChildTabWrap>

          <ul css={ItemList}>
            {contents}
          </ul>
        </div>

        <ProductDetail track={detailTrack} onCloseDetail={() => setDetailItemId(0)}/>
      </ItemListWrapper>
      {/* S캐시가 부족할때 띄어지는 창입니다. */}
      <Modal
        visible={visibleInsufficient}
        closable={false}
        onOk={handleOk}
        style={{ top: '180px', maxWidth: 270 }}
        bodyStyle={{ padding: '50px 0 30px', textAlign: 'center' }}
        footer={
          <ButtonWrap>
            <Button css={CancelButtonStyle} onClick={handleOk}>
              취소
            </Button>
            <Button css={ScashButtonStyle} onClick={onClickChargeInDetail}>
              S캐시 충전
            </Button>
          </ButtonWrap>
        }
      >
        S캐시가 부족합니다.
        <br/>
        충전하시겠습니까?
        <ModalBg onClick={handleOk}/>
      </Modal>

      <MessageArrivalButton key="ItemShop:MessageArrivalButton"/>
      {isMobile && <NavBar key="ItemShop:NavBar"/>}
    </Fragment>
  )
}

export default observer(ItemShop)
